export const LOGO = "/brand/LUMACOFONO_LOGO_ORIGINALE.jpeg";

export const SITE_URL = process.env.REACT_APP_SITE_URL;
export const CIURMA_URL = process.env.REACT_APP_CIURMA_URL;

export const PROJECTS = [
  { id: "fruttipedia", label: "Fruttipedia", url: process.env.REACT_APP_FRUTTIPEDIA_URL, sameTab: true },
  { id: "ciurma", label: "Crea la tua ciurma", url: CIURMA_URL },
  { id: "sbustaop", label: "SbustaOP", url: process.env.REACT_APP_SBUSTAOP_URL },
];

export const SOCIALS = [
  { id: "spotify", label: "Spotify", url: "https://open.spotify.com/show/2QRg3xuiNzzMweAuAr46zT" },
  { id: "youtube", label: "YouTube", url: "https://youtube.com/@lumacofonopodcast" },
  { id: "instagram", label: "Instagram", url: "https://www.instagram.com/lumacofono_podcast" },
  { id: "tiktok", label: "TikTok", url: "https://www.tiktok.com/@lumacofono.podcast" },
  { id: "twitch", label: "Twitch", url: "https://twitch.tv/lumacofono" },
];

export const CONTACT_EMAIL = "lumacofonopodcast@gmail.com";

export const ext = { target: "_blank", rel: "noopener noreferrer" };
